const COIN = "/brand/zrope-coin.png";

// Reusable ZRo Pe Coin visual. 1,000 coins = ₹1 (server is source of truth for conversions).
export function CoinIcon({ size = 22, className = "" }) {
  return <img src={COIN} alt="ZRo Pe Coin" className={`inline-block rounded-full object-cover ${className}`} style={{ width: size, height: size }} />;
}

export function CoinBadge({ coins, size = 22, className = "", dark = false }) {
  const n = Number(coins || 0);
  return (
    <span className={`inline-flex items-center gap-1.5 font-bold ${dark ? "text-white" : "text-[#0B132B]"} ${className}`} data-testid="coin-badge">
      <CoinIcon size={size} />
      {n.toLocaleString("en-IN")}
    </span>
  );
}

export const coinsToRupees = (coins, perRupee = 1000) => (Number(coins || 0) / perRupee);
